import { WebView } from '@/components/common/Layout'
import { NextPageWithLayout } from '@/pages/_app.page'

import { PrivacyPolicy } from './PrivacyPolicy'
import { useTranslation } from '@/i18n/configs'

const PrivacyPolicyRoute: NextPageWithLayout = () => {
  const t = useTranslation()
  const title = t('rules.privacy_policy', { defaultValue: '' })

  return (
    <WebView title={title}>
      <PrivacyPolicy />
    </WebView>
  )
}

export default PrivacyPolicyRoute
